import styled, { css } from 'styled-components'
import { px2rem } from 'styles/globals';

interface IRow{
  reverse?: boolean
}

const Wrapper = styled.div`
  margin-bottom: 60px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${px2rem(24)};
`;

const SectionTitle = styled.h1`
  font-weight: 800;
  font-size: 20px;
  ${props =>
    props.color &&
    css`
      color: ${props.color};
    `}
  @media screen and (min-width: 998px){
    font-size: var(--font-larger);
  }
`;

const Row = styled.div<IRow>`
  display: flex;
  flex-direction: column;
  width: 100%;
  @media screen and (min-width: 998px){
    justify-content: space-between;
    flex-direction: row;
    gap: 15px;
    padding-top: 10px;
    &.spot{
      display: grid;
      grid-template-columns: repeat(4,1fr);
      gap: 15px;
    }
    >div:first-of-type{
      width: 50%;
    }
    ${props => props.reverse ?  
      `
        flex-direction: row-reverse;
      ` 
      : `
        flex-direction: row;
      ` 
    }
  }
  @media screen and (max-width: 997px){
    align-items: center;
  }
`;

const RowSpot = styled.div`
  margin-top: ${px2rem(24)};
  gap: 15px;
  
  @media screen and (min-width: 998px){
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 15px;
    >div:not(:last-of-type){
      margin-right: ${px2rem(25)};
    }
  }
  @media screen and (max-width: 997px){
    display: flex;
    align-items: center;
    flex-direction: column;
    >article{
      display: flex;
      box-shadow: none;
      padding: 5px;
      >div{
        width: 70%;
        padding: 10px;
        height: auto;
        h1{ font-size: 18px; }
        p{ font-size: 14px; }
      }
    }
  }
    
`;



const Grid = styled.div`
  width: 100%;
  @media screen and (min-width: 998px){
    display: grid;
    align-items: flex-start;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: ${px2rem(25)};
    grid-template-rows: repeat(2, 1fr);
    width: 50%;
  }
  @media screen and (max-width: 997px){
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    
  }
`;

export{
  Wrapper,
  Header,
  Grid, 
  Row,
  RowSpot,
  SectionTitle
}